import { Component, OnInit, OnChanges, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ServiceAgreementComponent } from '../service-agreement/service-agreement.component';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../api.service';
import { DialogOverviewConfirmationComponent } from '../../dialog-overview-confirmation/dialog-overview-confirmation.component';
// import { SubscriptionPlansComponent } from 'subscription-plans/projects';
// import { SubscriptionPlansComponent } from 'subscription-plans';

@Component({
  selector: 'lib-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit, OnChanges {
  isRead;
  @Input() passAppList;
  @Input() userprinciplename;
  @Input() clientId;
  @Input() clientSecret;
  @Input() enableServiceView;
  @Input() productionFlag: boolean;
  serviceView: boolean = true;
  appView = false;
  // displayedColumns: string[] = ['appName', 'status', 'planName', 'facilityName', 'action'];
  displayedColumns: string[] = ['appName', 'status', 'facilityName', 'action'];

  dataSource = new MatTableDataSource<any>();
  serviceDisplayedColumns: string[] = ['serviceName', 'serviceId', 'versoin', 'secretKey'];
  servicedataSource = new MatTableDataSource<any>();
  searchValue: string;
  serviceType = 'serviceSubscription';
  copyInput = 'copyInput';
  isNotFound: boolean = false;
  showPagination: boolean = false;
  dataToPass: any;
  serviceAgreement: any;
  dataUsageAgreement: any;
  getSubscriptionList: any = {};
  profileData: any;
  getCurrentAppInfo: any = { applicationDetails: { isSubscriptionApprovalRequired: true, isUnsubscribeApprovalRequired: true } };
  @Input() facilityData: any = {};
  hideSubscribe: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @Output() dataEvent = new EventEmitter();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  showRequest: boolean = false;
  countryVal: string = '';
  // dialogRefSubscriptionPlan: MatDialogRef<SubscriptionPlansComponent, any>;
  dialogRefServiceAgreement: MatDialogRef<ServiceAgreementComponent, any>;
  constructor(
    private dialogBox: MatDialog, 
    private router: Router, 
    public translate: TranslateService, 
    private apiService: ApiService, 
    public dialog: MatDialog) { }

  ngOnInit() {
    if (!!localStorage.getItem('userObject')) {
      this.profileData = JSON.parse(localStorage.getItem('userObject'));
      if (this.profileData.accountType == 'Hartmann') {
        this.hideSubscribe = true;
      }
    }
    if (localStorage.getItem('role') == '5e0ddeb979070642cc9ef4b6') {
      this.showRequest = true;
    } else {
      this.displayedColumns = ['appName', 'status', 'action'];
    }
    this.countryVal = localStorage.getItem('countryVal');
  }

  isAppAvailableForCountry(item) {

  }
  ngOnChanges() {
    if (this.passAppList) {
      if (this.passAppList.profileAppList.length) {
        this.getSubscriptionList = JSON.parse(localStorage.getItem('subscriptionObject'));
        if (this.getSubscriptionList.dhhpAppsforUsers.length && this.getSubscriptionList.facilitySubscriptions.length) {
          this.getSubscriptionList.dhhpAppsforUsers.forEach((element, index) => {
            this.getSubscriptionList.facilitySubscriptions.forEach(childEle => {
              if (this.getSubscriptionList.dhhpAppsforUsers[index].appKey == childEle.appID) {
                element.planInfo = childEle;
                if (childEle.facilitySAPId == this.facilityData.facilitySAPId) {
                  element.facilityName = this.facilityData.facilityName;
                }
              }
            });
          });
        }
        if (this.getSubscriptionList.dhhpAppsforUsers.length) {
          var ds = this.getSubscriptionList.dhhpAppsforUsers.filter(res => res.appKey != "1");
          var ts = this.getUnique(ds, 'appId');
          // isAppAvailableForCountry(ds);
          var dataSourceCountry = [];
          for (var j = 0; j < ts.length; j++) {
            var retVal = false;
            for (var i = 0; i < ts[j].applicationSettings.length; i++) {
              if (ts[j].applicationSettings[i].country.toLowerCase() == localStorage.getItem('countryVal').toLowerCase()) {
                dataSourceCountry.push(ts[j]);
                break;
              }
            }
          }

          this.dataSource = new MatTableDataSource<any>(dataSourceCountry);
          if (this.dataSource.data.length == 0) {
            this.isNotFound = true;
          } else if (this.dataSource.data.length > 10) {
            this.isNotFound = false;
          } else {
            this.isNotFound = false;
          }
        } else {
          this.isNotFound = true;
        }
      }
      if (this.passAppList.serviceSubscriptions && this.passAppList.serviceSubscriptions.length) {
        let serviceData = this.passAppList.serviceSubscriptions.filter(res => res.country == localStorage.getItem('countryVal'));

        this.servicedataSource = new MatTableDataSource<any>(serviceData);
        // this.servicedataSource.sort = this.sort;
        // this.servicedataSource.paginator = this.paginator;
      }

    }
    if (!this.enableServiceView) {
      this.appView = true;
      this.serviceView = false;
    }
    if (localStorage.getItem('role') == '5e0ddeb979070642cc9ef4b6') {
      this.showRequest = true;
    }
  }

  getUnique(arr, comp) {

    // store the comparison  values in array
    const unique = arr.map(e => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e]).map(e => arr[e]);

    return unique;
  }

  removeSearchText() {
    this.searchValue = '';
    this.applyFilter('');
  }

  applyFilter(value) {
    this.servicedataSource.filter = value.trim().toLowerCase();
  }

  resetPaginator() {
    if (this.servicedataSource.paginator) {
      this.servicedataSource.paginator.firstPage();
    }
    if (this.servicedataSource.filteredData.length == 0) {
      this.isNotFound = true;
    }
    else {
      this.isNotFound = false;
    }
    if (this.servicedataSource.filteredData.length > 10) {
      this.showPagination = true;
    }
    else {
      this.showPagination = false;
    }
  }

  serviceTypeChange(event) {
    this.searchValue = '';
    this.filterServiceList(event);
    this.removeSearchText();
  }

  unsubscribeApp(data) {
    if (data.applicationSettings.length) {
      this.getCurrentAppInfo = data.applicationSettings.find(res => res.country == localStorage.getItem('countryVal'));
    }
    if (this.getCurrentAppInfo.applicationDetails.isSubscriptionApprovalRequired) {
      let formData = {
        userId: this.userprinciplename,
        appId: data.appKey,
        isApproved: true
      }
      this.apiService.unSubscribeAppNoApproval(formData).subscribe({
        next: (data: any) => {
          this.dataSource = new MatTableDataSource<any>(this.dataSource.data.filter(res => res.appKey != data.appKey));
        },
        error: err => { },
        complete: () => { }
      })
    } else {
      this.updateProfileDetails(data)
    }
  }

  appDesubscribe(data, comments) {
    const formData = {
      appId: data.appKey,
      userId: this.userprinciplename,
      comments: comments,
      country: localStorage.getItem('countryVal')
    }
    this.apiService.unSubscribeApp(formData).subscribe({
      next: (data: any) => {
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data.filter(res => res.appId != data.appKey));
      },
      error: err => { },
      complete: () => { }
    })
  }

  getRecord(event) {
    const formData = {
      serviceId: event.serviceId,
      userId: this.userprinciplename
    }
    this.apiService.redirectToService(formData).subscribe(data => {
      if (data) {
        this.apiService.serviceDetailsFromProfile = data;
        if (event.serviceCatalogType == 'Front-end') {
          this.router.navigate([`/service/frontendservice/${event.serviceId}`]);
        } else if (event.serviceCatalogType == 'Back-end') {
          this.router.navigate([`/service/backendservice/${event.serviceId}`]);
        } else if (event.serviceCatalogType == 'Integration') {
          this.router.navigate([`/service/integrateservice/${event.serviceId}`]);
        }
      }
    })
  }

  openRequestPlan(data) {
    const dialogRef = this.dialog.open(DialogOverviewConfirmationComponent, {
      panelClass: 'consentCls-planing',
      disableClose: true
    });
    this.dataToPass = {
      subscriptionPlanDetails: true,
      planData: data,
      facilityData: this.facilityData,
    };
    dialogRef.componentInstance.confirmData = this.dataToPass;
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'planSent') {
        this.dataEvent.emit({ event: "planSent" });
      }
    })
  }

  getSubscription(state) {
    var pos = "";
    var selectedPlanName = "";
    let subsObj = JSON.parse(localStorage.getItem('subscriptionObject'));
    var idx = subsObj.facilitySubscriptions.findIndex(x => x.appID == state.appKey);
    let requestedPlanObj = subsObj.facilitySubscriptions[idx].requestedPlan;

    let subscriptionPlans = state.applicationSettings.filter(ele => ele.country == this.facilityData.facilityCountry);
    if (subscriptionPlans.length > 0) {
      var pos_idx = subscriptionPlans[0].subscriptionPlans.map(function (e) { return e.planId; }).indexOf(state.planInfo.planId);
      pos = subscriptionPlans[0].subscriptionPlans.map(function (e) { return e.planId; })[pos_idx];
      selectedPlanName = subscriptionPlans[0].subscriptionPlans.map(function (e) { return e.planName; })[pos_idx];
    }

    // let config = {
    //   passedData: state,
    //   subscriptionPlans: subscriptionPlans,
    //   planId: pos,
    //   planName: selectedPlanName,
    //   requestedPlan: requestedPlanObj
    // };

    // this.dialogRefSubscriptionPlan = this.dialog.open(SubscriptionPlansComponent, {
    //   hasBackdrop: true,
    //   width: '90%',
    //   maxWidth: '80vw',
    //   height: '80%',
    //   panelClass: 'privacy-consentCls',
    //   disableClose: true,
    // });

    // this.dialogRefSubscriptionPlan.afterClosed().subscribe(result => {
    //   if (result.event == 'planSelected') {
    //     var facility = JSON.parse(localStorage.getItem('userObject'))['associatedAccounts'];
    //     var facilityName = '';
    //     var facilityCRMId = '';
    //     for (let i = 0; i < facility.length; i++) {
    //       if (facility[i]['facilityCRMId'] == state.planInfo.facilityCRMId) {
    //         facilityName = facility[i]['facilityName'];
    //         facilityCRMId = facility[i]['facilityCRMId'];
    //       }
    //     }

    //     var postParams = {
    //       "appId": state.appKey,
    //       "appName": state.appName,
    //       "siteName": facilityName,
    //       "planName": result.data.requestedPlanName,
    //       "country": localStorage.getItem('countryVal'),
    //       "language": localStorage.getItem('Lang'),
    //       "crmAccountid": facilityCRMId,
    //       "agreementDate": (new Date().getDate() < 10 ? ('0' + new Date().getDate()) : (new Date().getDate())) + "-" + ((new Date().getMonth() + 1) < 10 ? ('0' + (new Date().getMonth() + 1)) : ((new Date().getMonth() + 1))) + "-" + new Date().getFullYear(),
    //       "price": result.data.monthlyCost ? result.data.monthlyCost : this.translate.instant("For Free")
    //     }
    //     this.apiService.getFacilityAppSubscriptionAgreementPost(postParams).subscribe(
    //       data => {
    //         this.dialogRefServiceAgreement = this.dialogBox.open(ServiceAgreementComponent, {
    //           hasBackdrop: true,
    //           width: '75%',
    //           disableClose: true,
    //           autoFocus: false
    //         });
    //         this.dialogRefServiceAgreement.componentInstance.passedData = { data: data, showActionButtons: true };
    //         this.dialogRefServiceAgreement.afterClosed().subscribe(resultVal => {
    //           this.serviceAgreement = resultVal.serviceAgreement;
    //           this.dataUsageAgreement = resultVal.dataUsageAgreement;
    //           if (resultVal.event == 'agree') {
    //             const formData = {
    //               agreement: this.serviceAgreement,
    //               dataUsageAgreement: this.dataUsageAgreement ? this.dataUsageAgreement : "",
    //               facilitySAPId: result.data.formSAPId,
    //               facilityCRMId: result.data.formCRMId,
    //               appID: result.data.appId,
    //               planId: config.planId,
    //               planName: config.planName,
    //               lastModifiedDate: result.data.updatedOn,
    //               lastModifiedBy: result.data.userName,
    //               status: result.data.isActive,
    //               requestedPlan: {},
    //               subscriptionType: '',
    //               country: localStorage.getItem('countryVal'),
    //               facilityname: result.data.facilityName,
    //             }
    //             formData.requestedPlan = {
    //               planId: result.data.requestedPlanId,
    //               planName: result.data.requestedPlanName,
    //               userId: localStorage.getItem('user_token'),
    //               requestedDate: new Date(),
    //               requestStatus: true
    //             }

    //             this.apiService.updateFacilitySubscriptionSetup(true, formData).subscribe({
    //               next: res => {
    //                 let subscriptionObj = JSON.parse(localStorage.getItem('subscriptionObject'));
    //                 var pos_idx = subscriptionObj.facilitySubscriptions.findIndex(x => x.appID == state.appKey);
    //                 if (pos_idx != -1) {
    //                   subscriptionObj.facilitySubscriptions[pos_idx].requestedPlan = formData.requestedPlan;
    //                   localStorage.setItem('subscriptionObject', JSON.stringify(subscriptionObj));
    //                 }
    //               },
    //               error: err => {

    //               }
    //             })
    //           }
    //         });
    //       });
    //   }
    // });
    // let instance = this.dialogRefSubscriptionPlan.componentInstance;
    // instance.config = config;
  }

  updateProfileDetails(dataView) {
    const dialogRef = this.dialog.open(DialogOverviewConfirmationComponent, {
      width: '500px',
      disableClose: true
    });
    this.dataToPass = {
      unsubscribeAppData: true,
    };
    dialogRef.componentInstance.confirmData = this.dataToPass;
    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'appModify') {
        this.appDesubscribe(dataView, result.notes);
      }
    });
  }

  copyText(i) {
    let copyText = document.getElementById("copyInput" + i) as HTMLInputElement;
    copyText.select();
    copyText.setSelectionRange(0, 99999)
    document.execCommand("copy");
  }

  filterServiceList(event) {
    switch (event) {
      case 'serviceSubscription':
        this.serviceView = true;
        this.appView = false;
        break;
      case 'appSubscription':
        this.appView = true;
        this.serviceView = false;
        break;
    }

  }

  getAppName(item) {
    if (item.countryAppNames.length > 0) {
      var appName = item.countryAppNames.filter(res => res.country == localStorage.getItem('countryVal'));
      if (appName.length > 0) {
        return appName[0].appName;
      } else {
        return item.appName;
      }
    } else {
      return item.appName;
    }
  }

  viewServiceAgreement(state) {
    console.log("**");
    console.log(state)
    var facility = JSON.parse(localStorage.getItem('userObject'))['associatedAccounts'];
    var facilityName = '';
    var facilityCRMId = '';
    for (let i = 0; i < facility.length; i++) {
      if (facility[i]['facilityCRMId'] == state.planInfo.facilityCRMId) {
        facilityName = facility[i]['facilityName'];
        facilityCRMId = facility[i]['facilityCRMId'];
      }
    }

    var planVal = state.applicationSettings.filter(res => res.country == localStorage.getItem('countryVal'));
    var subPlans = [];
    if (planVal.length > 0) {
      subPlans = planVal[0].subscriptionPlans.filter(res => res.planId == state.planInfo.planId)
    }
    var formData = {
      "appId": state.appKey,
      "appName": state.appName,
      "siteName": facilityName,
      "planName": state.planInfo.planName,
      "country": localStorage.getItem('countryVal'),
      "language": localStorage.getItem('Lang'),
      "crmAccountid": facilityCRMId,
      "agreementDate": (new Date(state.planInfo.lastModifiedDate).getDate() < 10 ? ('0' + new Date(state.planInfo.lastModifiedDate).getDate()) : (new Date(state.planInfo.lastModifiedDate).getDate())) + "-" + ((new Date(state.planInfo.lastModifiedDate).getMonth() + 1) < 10 ? ('0' + (new Date(state.planInfo.lastModifiedDate).getMonth() + 1)) : ((new Date(state.planInfo.lastModifiedDate).getMonth() + 1))) + "-" + new Date(state.planInfo.lastModifiedDate).getFullYear(),
      "price": subPlans.length > 0 ? (subPlans[0].monthlyCost != "" ? subPlans[0].monthlyCost : this.translate.instant("For Free")) : ''
    }
    this.apiService.getFacilityAppSubscriptionAgreementPost(formData).subscribe(
      data => {
        this.dialogRefServiceAgreement = this.dialogBox.open(ServiceAgreementComponent, {
          hasBackdrop: true,
          width: '75%',
          disableClose: true,
          autoFocus: false
        });
        this.dialogRefServiceAgreement.componentInstance.passedData = { data: data, showActionButtons: false };
        this.dialogRefServiceAgreement.afterClosed().subscribe(result => {
          if (result.event == 'agree') {
          }
        });
      });
  }
}
